import { useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Mail, ArrowLeft, CheckCircle } from "lucide-react";
import { toast } from "sonner";

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await fetch(`${API_URL}/api/auth/forgot-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });
      if (res.ok) {
        setSent(true);
      } else {
        const data = await res.json();
        toast.error(data.detail || "Failed to send reset email");
      }
    } catch {
      toast.error("Network error");
    } finally {
      setLoading(false);
    }
  }

  if (sent) {
    return (
      <div className="min-h-screen bg-stone-950 flex items-center justify-center px-4" data-testid="forgot-password-success">
        <div className="w-full max-w-md text-center">
          <CheckCircle className="w-16 h-16 text-emerald-500 mx-auto mb-6" />
          <h1 className="text-2xl font-bold text-white mb-3">Check Your Email</h1>
          <p className="text-stone-400 mb-8">If an account exists with <span className="text-amber-400">{email}</span>, we've sent a password reset link.</p>
          <Link to="/login"><Button variant="outline" className="border-stone-700 text-stone-300 rounded-xl"><ArrowLeft className="w-4 h-4 mr-2" />Back to Login</Button></Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-stone-950 flex items-center justify-center px-4" data-testid="forgot-password-page">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-white mb-2">Reset Password</h1>
          <p className="text-stone-400">Enter your email to receive a reset link</p>
        </div>
        <form onSubmit={handleSubmit} className="bg-stone-900/60 border border-stone-800 rounded-2xl p-8 space-y-6">
          <div>
            <Label className="text-stone-300">Email Address</Label>
            <div className="relative mt-1">
              <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-stone-500" />
              <Input type="email" value={email} onChange={e => setEmail(e.target.value)} required placeholder="your@email.com" className="pl-10 bg-stone-800 border-stone-700 text-white rounded-xl" data-testid="forgot-email-input" />
            </div>
          </div>
          <Button type="submit" disabled={loading} className="w-full bg-amber-600 hover:bg-amber-700 text-white rounded-xl py-5" data-testid="forgot-submit-btn">
            {loading ? "Sending..." : "Send Reset Link"}
          </Button>
          <div className="text-center">
            <Link to="/login" className="text-amber-400 hover:text-amber-300 text-sm">Back to Login</Link>
          </div>
        </form>
      </div>
    </div>
  );
}
